module.exports = __webpack_public_path__ + "static/media/autumnAkiu.83bd80da.jpg";